import { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getCourseReviews, addCourseReview } from 'actions/educations';

export function useCourseReviews(courseId, { limit = 10, auto = true } = {}) {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReviews = useCallback(
    (params = {}) => {
      if (!courseId) return Promise.resolve([]);
      setLoading(true);
      return dispatch(getCourseReviews(courseId, { limit, offset: 0, ...params })).then((res) => {
        if (Array.isArray(res)) setItems(res);
        setLoading(false);
        return res;
      });
    },
    [dispatch, courseId, limit]
  );

  const submitReview = useCallback(
    async ({ ratings, message }) => {
      if (!courseId) return;
      const markArray = Object.entries(ratings || {}).map(([k, v], idx) => ({
        [`parameter${idx + 1}`]: v
      }));
      await dispatch(addCourseReview(courseId, { markArray, text: message }));
      await fetchReviews();
    },
    [dispatch, courseId, fetchReviews]
  );

  useEffect(() => {
    if (auto && courseId) fetchReviews();
  }, [auto, courseId, fetchReviews]);

  return { reviews: items, loading, fetchReviews, submitReview };
}
